import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {numVal} from '../../../../modules/Utils'
import InfoText from '../../../../elements/InfoText'
import State from '../../../../elements/State'
import {isEmpty} from 'lodash'
import CustomTable from '../../../../elements/Table/CustomTable'
import DateCell from '../../../../elements/Table/Cells/DateCell'

const LeaveTypeCell = ({value}) =>
  !isEmpty(value) && `${numVal(value, 'entitled')} / ${numVal(value, 'taken')}`

class Entitlements extends Component {
  async componentDidMount() {
    await this.props.fetchEntitlements()
  }

  columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Start',
      accessor: 'date.start',
      Cell: DateCell,
    },
    {
      Header: 'End',
      accessor: 'date.end',
      Cell: DateCell,
    },
    {
      Header: 'Annual',
      accessor: 'leaves.AL',
      Cell: LeaveTypeCell,
    },
    {
      Header: 'Carry Over Leave',
      accessor: 'leaves.COL',
      Cell: ({value}) =>
        !isEmpty(value) &&
        `${numVal(value, 'entitled')} / ${numVal(value, 'taken')}`,
    },
    {
      Header: 'Sick',
      accessor: 'leaves.MC',
      width: 65,
      Cell: LeaveTypeCell,
    },
    {
      Header: 'In Lieu',
      accessor: 'leaves.LL',
      width: 65,
      Cell: LeaveTypeCell,
    },
    {
      Header: 'Compassionate',
      accessor: 'leaves.CL',
      Cell: LeaveTypeCell,
    },
    {
      Header: 'Status',
      accessor: 'active',
      Cell: ({value}) => (
        <State tooltip={false} value={value === true ? 'Active' : 'Inactive'} />
      ),
    },
  ]

  render() {
    const {entitlements, fetchEntitlements, fetchingEntitlements} = this.props
    return (
      <Fragment>
        <CustomTable
          fetch={fetchEntitlements}
          columns={this.columns}
          data={entitlements}
          loading={fetchingEntitlements}
        />
        <InfoText text={'Click on the ID to view and update Leave'} />
        <InfoText text={'Tip: Hold shift when sorting to multi-sort!'} />
      </Fragment>
    )
  }
}

Entitlements.propTypes = {
  entitlements: PropTypes.array,
  fetching: PropTypes.bool,
}
Entitlements.defaultProps = {entitlements: [], fetching: false}

export default Entitlements
